// Spanish translations - modular structure
import { nav } from './nav.js';
import { hero } from './hero.js';
import { home } from './home.js';
import { about } from './about.js';
import { leadership } from './leadership.js';
import { vision } from './vision.js';
import { products } from './products.js';
import { contact } from './contact.js';
import { structure } from './structure.js';
import { compliance } from './compliance.js';
import { businessModel } from './businessModel.js';
import { operations } from './operations.js';
import { brochures } from './brochures.js';
import { footer } from './footer.js';
import { privacy } from './privacy.js';
import { terms } from './terms.js';
import { cookies } from './cookies.js';
import { legal } from './legal.js';

export const es = {
  nav,
  hero,
  home,
  about,
  leadership,
  vision,
  products,
  contact,
  structure,
  compliance,
  businessModel,
  operations,
  brochures,
  footer,
  privacy,
  terms,
  cookies,
  legal,
};
